<div class="inline-flex p-error block">
  <i class="pi pi-info-circle info-circle-icon"></i>
  <small class="font-medium"> {{ errorMessage }}</small>
</div>
